import React, {FC, useEffect} from "react";
import {useSelector} from "react-redux";
import {IReduxState} from "../../../ReduxImpl/reducers/index";
import {useTranslation} from "react-i18next";
import {
  FieldTypes,
  FieldWithValueProps,
} from "@sitecore-jss/sitecore-jss-react-forms";
import {BiInfoCircle} from "react-icons/bi";
const FieldWrapper: FC<FieldWithValueProps> = (props) => {
  const {t} = useTranslation();

  const hasRadioBtn =
    props.field.model.fieldTypeItemId === FieldTypes.RadioButtonList;

  const hideButton = useSelector((state: IReduxState) => state.hideButton);
  const name = props.field.model.name;
  const captcha = useSelector((state: IReduxState) => state.captcha);

  let children = props.children;

  const createModalIntent: (className: string, id: string) => void = (
    className,
    id
  ) => {
    if (typeof document != "undefined")
      document.getElementById(id).classList.add(className);
  };

  if (name === "NewsletterModalButton" && !captcha) {
    children = (
      <div
        style={{
          height: "fit-content",
          width: "fit-content",
        }}
        onClick={() => {
          createModalIntent("newsletter-form", "NewsletterFormModalPopup");
        }}
      >
        {props.children}
      </div>
    );
  }

  if (name === "ContactUsModalButton" && !captcha) {
    children = (
      <div
        style={{
          height: "fit-content",
          width: "fit-content",
        }}
        onClick={() => {
          createModalIntent("contact-us-form", "ContactUsFormModalPopup");
        }}
      >
        {props.children}
      </div>
    );
  }

  if (name === "AppointmentModalButton" && !captcha) {
    children = (
      <div
        style={{
          height: "fit-content",
          width: "fit-content",
        }}
        onClick={() => {
          createModalIntent("appointment-form", "AppointmentFormModalPopup");
        }}
      >
        {props.children}
      </div>
    );
  }

  if (name === "SuccessSection") {
    children = (
      <div style={{height: 200, position: "relative"}}>
        <div
          id="newsletter_submit_confirmation"
          style={{
            height: "100%",
            position: "absolute",
            top: 0,
            right: 0,
            bottom: 0,
            left: 0,
            backgroundColor: "#fff",
            zIndex: 1,
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <div
            className="icon icon-ok"
            style={{fontSize: 83, color: "#03C51A"}}
          />
        </div>
        {props.children}
      </div>
    );
  }

  if (name === "ErrorSection") {
    children = (
      <div style={{height: 200}}>
        <div
          id="newsletter_submit_confirmation"
          style={{
            position: "absolute",
            top: 90,
            right: 0,
            bottom: 0,
            left: 0,
            backgroundColor: "#fff",

            display: "flex",
            justifyContent: "center",
          }}
        >
          <div
            id="form-error-icon"
            className="icon icon-error"
            style={{fontSize: 83, marginTop: 150, color: "white"}}
          />
        </div>
        {props.children}
      </div>
    );
  }

  if (name === "TopRightSection") {
    children = props.children;
  }

  return (
    <div
      className={`sitecore-jss-form__field-wrapper ${
        hasRadioBtn ? "sitecore-jss-form__field-wrapper--radio-btn" : ""
      } ${
        name === "contactUs"
          ? "sitecore-jss-form__field-wrapper--contactUs"
          : ""
      } ${
        name === "section-form"
          ? "sitecore-jss-form__field-wrapper--section-form"
          : "section-form"
      } ${
        name === "ContactUsModalButton"
          ? "sitecore-jss-form__field-wrapper--SubButton"
          : ""
      } ${
        name === "form__wrapper__columnLeft"
          ? "sitecore-jss-form__field-wrapper--form__wrapper__columnLeft"
          : ""
      } ${
        [
          "Subject",
          "CountryIso",
          "Name",
          "Surname",
          "Email",
          "ConfirmEmailSection",
          "Phone",
          "CRMLQLanguageCode",
          "City",
          "Province",
          "SelectRegion",
          "Region",
          "PostalCode",
          "CRMLQApplicationCode",
          "CRMLQContactMethodCode",
        ].includes(name)
          ? "sitecore-jss-form__field-wrapper--Subject"
          : ""
      } ${
        name === "form__wrapper__columnRight"
          ? "sitecore-jss-form__field-wrapper--form__wrapper__columnRight"
          : ""
      } ${
        name === "IDDocument"
          ? "sitecore-jss-form__field-wrapper--fileupload"
          : ""
      } ${
        name === "ChangeLanguageText"
          ? "sitecore-jss-form__field-wrapper--ChangeLanguageText"
          : ""
      } ${
        name === "FormInfoText"
          ? "sitecore-jss-form__field-wrapper--FormInfoText"
          : ""
      } ${
        name === "PrivacyPolicyText"
          ? "sitecore-jss-form__field-wrapper--PrivacyPolicyText"
          : ""
      } ${
        name === "DataCategoriesText"
          ? "sitecore-jss-form__field-wrapper--DataCategoriesText"
          : ""
      } ${
        name === "SubscribeButton" && hideButton
          ? "sitecore-jss-form__field-wrapper--DisableSubscribeButton"
          : "sitecore-jss-form__field-wrapper--EnableSubscribeButton"
      } ${
        name === "SubscribeButton" && captcha
          ? "sitecore-jss-form__field-wrapper--DisableSubscribeButton"
          : ""
      } ${
        name === "SubmitButton" && captcha
          ? "sitecore-jss-form__field-wrapper--DisableSubmitButton"
          : ""
      } ${
        name === "SubmitButton" && !captcha
          ? "sitecore-jss-form__field-wrapper--SubmitButton"
          : ""
      } ${
        name === "SubscriberText"
          ? "sitecore-jss-form__field-wrapper--subscribeText"
          : ""
      } ${
        name === "requestAnAppointment"
          ? "sitecore-jss-form__field-wrapper--RequestAnAppointment"
          : ""
      } ${
        name === "Captcha" ? "sitecore-jss-form__field-wrapper--Captcha" : ""
      } ${
        name === "submitButton"
          ? "sitecore-jss-form__field-wrapper--Request"
          : ""
      } ${
        captcha &&
        [
          "NewsletterModalButton",
          "ContactUsModalButton",
          "AppointmentModalButton",
        ].includes(name)
          ? "disabled"
          : ""
      }

      ${
        (props.field.model.cssClass as string)?.length > 0
          ? (props.field.model.cssClass as string)
          : ""
      }
     `}
    >
      {["form__wrapper__columnRight", "form__wrapper__columnLeft"].includes(
        name
      ) && (
        <div
          className={`sitecore-jss-form__field-wrapper__required_fields_${
            name === "form__wrapper__columnLeft" ? "first" : "second"
          }`}
        >
          {name === "form__wrapper__columnRight" && (
            <div className="form__wrapper__columnRight_text">{`* ${t(
              "RequiredField"
            )}`}</div>
          )}
        </div>
      )}
      {/* {"DEBUG"} {name} {props.field.model.fieldTypeItemId} */}
      {/* {name === "Captcha" ? null : children} */}
      {children}
      {name === "IDDocument" ? (
        <div>
          <div className="sitecore-jss-form__field-wrapper--file">
            <div>
              <BiInfoCircle className="sitecore-jss-form__field-wrapper--file-icon" />
            </div>
            <div className="sitecore-jss-form__field-wrapper--file-label">
              <label>
                File size: max 5MB <br />
                File formats allowed:png, jpg, bmp, jpeg, pdf
              </label>
            </div>
          </div>
        </div>
      ) : null}
    </div>
  );
};

export default FieldWrapper;
